<template>
  <div class="info_page">
    <Header></Header>
    <div class="contain" style="margin-top: 40px;">
    <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'AppResourceAdd', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="info_cont">
    	    <div class="cont"><h1>{{item.title}}</h1></div>
          <div class="tip">
            <span class="author">作者：{{(item.user)?item.user.username:''}}</span>
            <el-button size="mini" style="float: right;" type="primary" @click="donwload">立即下载</el-button>
          </div>
              <Preview :info="attachment" v-if="loading"></Preview>
          </div>
        </el-card>
      </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/header'
import Footer from '@/components/footer' 
import Preview from '@/components/preview'

import { resInfo } from '@/api/'
export default {
  name: 'AppResourceInfo',
  data() {
    return {
      attachment: null,
      item: {},
      loading: false,
      nav: {
        id: '100',
        name: '资源中心'
      }
    }
  },
  created(e) {
  	resInfo({id: this.$route.params.id}).then(res=>{
  		this.attachment = res.attachment
  		this.item = res
  		this.loading = true
  	})
  },
  components: {
    Preview, Header, Footer
  },
  methods: {
    donwload(){
      if(!this.attachment) {
        this.$message({
          type: 'error',
          message: '下载失败，文件不存在'
        })
        return
      }
      window.open(this.attachment.file)
    }
  }
}
</script>
<style scoped>
    .info_page{  }
    .tip{ margin: 20px auto; }
    .info_cont{ padding:60px; width:1080px; margin:0 auto; box-shadow:0px 0px 5px #888; background:#fff;}
</style>